<div class="container">

  <app-header-dialog [iconName]="'multiple_stop'">
    <span>{{ordered.member_name}} </span>
  </app-header-dialog>

  <div class='content'>

    <mat-card>
      <div class='order-item'>
        <div class='label'>
          Data:
        </div>
        <div class='value'>
          {{ ordered.date | date:'dd/MM/yyyy' }}
        </div>

      </div>

      <div class='order-item'>
        <div class='label'>
          Produto:
        </div>
        <div class='value'>
          {{ ordered.product_name }}
        </div>
      </div>

      <div class='order-item'>
        <div class='label'>
          Cliente:
        </div>
        <div class='value'>
          {{ ordered.member_name }}
        </div>
      </div>

      <div class='order-item'>
        <div class='label'>
          Categoria:
        </div>
        <div class='value'>
          {{ ordered.category_name }}
        </div>
      </div>

      <div class='order-item'>
        <div class='label'>
          Origem:
        </div>
        <div class='value'>
          {{ ordered.origin }}
        </div>
      </div>


      <div class='order-item'>
        <div class='label'>
          Valor:
        </div>
        <div class='value'>
          {{ ordered.total | currency:'BRL':'':'1.2-2' }}
        </div>
      </div>

    </mat-card>


    <mat-card>

      <form class="form" name="entityForm" [formGroup]='entityForm' autocomplete="off">

        <mat-form-field class="date-width" appearance="outline">
          <mat-label>Pagamento</mat-label>
          <input matInput [matDatepicker]="picker" [errorStateMatcher]="matcher"
            [formControl]="entityForm.controls.payment_date">
          <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
          <mat-datepicker #picker></mat-datepicker>
          <mat-error *ngIf="entityForm.controls.payment_date.hasError('required')">
            O data de pagamento é obrigatória
          </mat-error>
        </mat-form-field>

      </form>

    </mat-card>

  </div>

  <div class="actions" fxLayoutAlign="end" flex justify-content='flex-end'>
    <div [ngClass]="{hidden: !spinner}">
      <mat-spinner diameter="30"></mat-spinner>
    </div>
    <button mat-raised-button (click)='updateOrder()'>
      <mat-icon class='icon-done'>check_circle_outline</mat-icon>
    </button>
  </div>


</div>